import React, { useState, useEffect, useMemo } from 'react';
import { parse, format, isValid } from 'date-fns';

const TotalUsers = () => {
  const [userList, setUsersList] = useState([]);
  const BUId = sessionStorage.getItem('BUId');
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Login/GetUserList`);

        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await userResponse.json();
        setUsersList(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserData();
  }, [BUId]);

  const parseCustomDate = (dateString) => {
    if (!dateString) return null;

    const formats = [
      'dd-MM-yyyy HH:mm:ss',
      'MM/dd/yyyy hh:mm:ss a',
      'dd/MM/yyyy hh:mm:ss a'
    ];

    for (const formatStr of formats) {
      const parsedDate = parse(dateString, formatStr, new Date());
      if (isValid(parsedDate)) {
        return parsedDate;
      }
    }

    return null;
  };

  const formatCustomDate = (date) => {
    if (!date || !isValid(date)) return 'Invalid Date';
    return format(date, 'dd/MM/yyyy hh:mm a');
  };

 // Filter and search functionality
  const filteredMails = useMemo(() => {
    const normalizedSearchTerm = searchTerm.toLowerCase();

    return userList.filter(user => {
     const matchesUser = user.buName &&
  user.buName.toLowerCase().includes(normalizedSearchTerm);

      
     // const matchesSender = user.fromEmail.toLowerCase().includes(normalizedSearchTerm);
    //  const matchesMailType = user.mailType.toLowerCase().includes(normalizedSearchTerm);
      const matchesDate = user.createdOn.toLowerCase().includes(normalizedSearchTerm);
      return matchesUser || matchesDate; //matchesSender || matchesMailType ||
    });
  }, [userList, searchTerm]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMails.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredMails.length / itemsPerPage);

  
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="container mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
      {/* Header */}
        <div className="bg-gray-200 p-4">
          <h1 className="text-xl ">User Details</h1>
        </div>

        {/* Search Input */}
        <div className="p-4 bg-gray-100 border-b">
          <div className="max-w-md ml-auto relative">

            <input
              type="text"
              placeholder="Search..."
              className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 absolute left-3 top-3 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

          <div className="overflow-x-auto">
          <table className="w-full  table-fixed">
          <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">BU Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Created On</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
                  {currentItems.length > 0 ? (
                currentItems.map((user, index) => (
            //{userList.length > 0 ? (
             // userList.map((user, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{user.buName}</td>
                  <td className="px-6 py-4 text-sm">
                    <span
                      className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${user.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
                    >
                      {user.isActive ? 'Active' : 'InActive'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {formatCustomDate(parseCustomDate(user.createdOn))}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-6 py-4 text-sm text-center text-gray-600">No users found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
       {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
    </div>
    </div>
  );
};

export default TotalUsers;
